
import Vue from 'vue';
import { faChevronDown } from '@delfi.lt/fa-kit/icons/modules/classic/solid';

interface Methods {
  scrollToElement: () => void;
}

export default Vue.extend<unknown, Methods, unknown, unknown>({
  data() {
    return {
      faChevronDown,
    };
  },
  methods: {
    scrollToElement() {
      const scrollToElement = window.document.getElementsByClassName('article')[0];
      if (scrollToElement) {
        scrollToElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
});
